import { ComponentPropsWithoutRef } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCopy } from 'components/snippet/useCopy';
import { twMerge } from 'tailwind-merge';

interface CopyButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'color'> {
    text: string;
    inPortal?: boolean;
}

const CopyButton = (props: CopyButtonProps) => {
    const {
        text,
        className = '',
        inPortal = false,
        children,
        onClick: onClickConsumer,
        ...rest
    } = props;
    const { didCopy, onClickCopy } = useCopy({ inPortal });

    return (
        <Button
            variant="transparent"
            color="neutral"
            size="xs"
            className={twMerge('rounded-full hover:bg-gray-100', className)}
            onClick={e => {
                onClickCopy(e, text);
                onClickConsumer?.(e);
            }}
            aria-label="Copy"
            {...rest}
        >
            {children}
            <FontAwesomeIcon icon={didCopy ? faCheck : faCopy} />
        </Button>
    );
};

export { CopyButton };
export type { CopyButtonProps };
